module.exports = __webpack_public_path__ + "img/pooqzone-logo.e993902b.png";